<template>
  <div class="container-fluid">    
    <h1 class="text-warning text-center">Servicios</h1>
    </br>
    <!-- Carrusel -->
    <Flicking :options="{horizontal: true, adaptive: false, circular: true, resizeOnContentsReady: true }" :plugins="plugins">
      <a
        href="#registro-anchor"
        class="card-panel is-small"
        @click.prevent="scrollToAnchor('registro-anchor')"
      >
        <span class="flicking-index">
          Constitución de sociedades
          <img src="/img/services2025/constitutiva.png" draggable="false" @dragstart.prevent style="user-select: none; pointer-events: none;" />          
        </span>
      </a>
      <a
        href="#registro-anchor"
        class="card-panel is-small"
        @click.prevent="scrollToAnchor('registro-anchor')"
      >
        <span class="flicking-index">
          Notificaciones
          <img src="/img/services2025/notif.png" draggable="false" @dragstart.prevent style="user-select: none; pointer-events: none;" />
        </span>
      </a>
      <a
        href="#registro-anchor"
        class="card-panel is-small"
        @click.prevent="scrollToAnchor('registro-anchor')"
      >
        <span class="flicking-index">
          Copias certificadas
          <img src="/img/services2025/cotejo.png" draggable="false" @dragstart.prevent style="user-select: none; pointer-events: none;" />
        </span>
      </a>
      <a
        href="#registro-anchor"
        class="card-panel is-small"
        @click.prevent="scrollToAnchor('registro-anchor')"
      >
        <span class="flicking-index">
          Avalúos de mejoras
          <img src="/img/services2025/avaluo.png" draggable="false" @dragstart.prevent style="user-select: none; pointer-events: none;" />
        </span>
      </a>
      <a
        href="#registro-anchor"
        class="card-panel is-small"
        @click.prevent="scrollToAnchor('registro-anchor')"
      >
        <span class="flicking-index">
          Firma digital de documentos
          <img src="/img/services2025/digital.png" draggable="false" @dragstart.prevent style="user-select: none; pointer-events: none;" />
        </span>
      </a>
      <a
        href="#registro-anchor"
        class="card-panel is-small"
        @click.prevent="scrollToAnchor('registro-anchor')"
      >
        <span class="flicking-index">
          Fecha cierta
          <img src="/img/services2025/fecha.png" draggable="false" @dragstart.prevent style="user-select: none; pointer-events: none;" />
        </span>
      </a>
      <a
        href="#registro-anchor"
        class="card-panel is-small"
        @click.prevent="scrollToAnchor('registro-anchor')"
      >
        <span class="flicking-index">
          Fe de hechos
          <img src="/img/services2025/fedehechos.png" draggable="false" @dragstart.prevent style="user-select: none; pointer-events: none;" />
        </span>
      </a>
      <a
        href="#registro-anchor"
        class="card-panel is-small"
        @click.prevent="scrollToAnchor('registro-anchor')"
      >
        <span class="flicking-index">
          Formalización de actas
          <img src="/img/services2025/globo.png" draggable="false" @dragstart.prevent style="user-select: none; pointer-events: none;" />
        </span>
      </a>
      <a
        href="#registro-anchor"
        class="card-panel is-small"
        @click.prevent="scrollToAnchor('registro-anchor')"
      >
        <span class="flicking-index">
          Ratificación de firmas
          <img src="/img/services2025/ratificaciones.png" draggable="false" @dragstart.prevent style="user-select: none; pointer-events: none;" />
        </span>
      </a>
      <a
        href="#registro-anchor"
        class="card-panel is-small"
        @click.prevent="scrollToAnchor('registro-anchor')"
      >
        <span class="flicking-index">
          Búsqueda en RPC
          <img src="/img/services2025/rpc.png" draggable="false" @dragstart.prevent style="user-select: none; pointer-events: none;" />
        </span>
      </a>
      <a
        href="#registro-anchor"
        class="card-panel is-small"
        @click.prevent="scrollToAnchor('registro-anchor')"
      >
        <span class="flicking-index">
          Búsqueda en RUG
          <img src="/img/services2025/rug.png" draggable="false" @dragstart.prevent style="user-select: none; pointer-events: none;" />
        </span>
      </a>
      <a
        href="#registro-anchor"
        class="card-panel is-small"
        @click.prevent="scrollToAnchor('registro-anchor')"
      >
        <span class="flicking-index">
          Cursos y capacitación
          <img src="/img/services2025/cursos.png" draggable="false" @dragstart.prevent style="user-select: none; pointer-events: none;" />
        </span>
      </a>
      <span slot="viewport" class="flicking-arrow-prev is-circle"></span>
      <span slot="viewport" class="flicking-arrow-next is-circle"></span>
    </Flicking>
    <!-- Fin del carrusel -->
  </div>
</template>

<script>
  import { Flicking } from "@egjs/vue-flicking";  
  import { Arrow } from "@egjs/flicking-plugins";

  export default {
    components: {
      Flicking
    },
    data() {
      return {                
        plugins: [new Arrow]
      } 
    },
    methods: {
      scrollToAnchor(anchor) {
        const el = document.getElementById(anchor);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  }
</script>

<style scoped>
  @import "~@egjs/vue-flicking/dist/flicking.css";
  @import "~@egjs/flicking-plugins/dist/flicking-plugins.css";

  .card-panel {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-radius: 0.25rem;
  box-shadow: 0 0.5em 1em -0.125em rgba(10.2, 10.2, 10.2, 0.1);
  max-width: 100%;
  font-size: 1.5rem;
  margin: 0.5rem;
  width: 50%;
  height: 400px;
  padding: 20px 20px;
  box-sizing: border-box;
  overflow: hidden;
  font-weight: bold;
}

.is-small {
  width: 25%;
}

/* Hide arrows by default, show only on small screens */
.flicking-arrow-prev,
.flicking-arrow-next {
  display: block;
}

/* Responsive: show only one card and arrows on small screens */
@media (max-width: 768px) {
  .card-panel,
  .is-small {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    margin: 0 auto;
  }
}

/* On large screens, show multiple cards and arrows */
@media (min-width: 769px) {
  .card-panel {
    width: 50%;
  }
  .is-small {
    width: 25%;
  }
  .flicking-arrow-prev,
  .flicking-arrow-next {
    display: block !important;
  }
}

.flicking-index {
  position: relative;
  min-width: 60px;
  text-align: center;
}

.flicking-index::after {
  position: absolute;
  /* content: "Conócelo"; */
  font-weight: bold;
  left: 0;
  bottom: -1.2rem;
  width: 100%;
  text-align: center;
  font-size: 1rem;
}
</style>